module.exports = __webpack_public_path__ + "img/eg-4.c0a19541.jpg";